import { getStore } from '../store/Store';

/**
 * Returns a flag indicating whether to show reading pane or not
 */
export default function shouldShowReadingPane() {
    return getStore().showReadingPane;
}
